import React, { Fragment } from 'react';
import {Button} from "semantic-ui-react";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import { setIsFinalDailyResult } from "../../../store/dailyResults/dailyResultSlice";
//import { DartsGame } from "../../../pages/Darts/EventManager/DartsEventManager.types";
//import { DartsGameType } from "../../../common/types/DartsGameTypes";

interface IDartsEventManagerInformButtonsProps {
    selectedTournament?: number
    selectedGame?: number
    selectedGroup: number
}

const DartsEventManagerInformButtons: React.FC<IDartsEventManagerInformButtonsProps> = ({selectedTournament, selectedGame, selectedGroup}) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const pages = useAppSelector(state => state.Auth.pages);

    const goToLeagueList = () => {
        if (selectedTournament && selectedGroup) {
            navigate(`/darts/leagues/${selectedTournament}/${selectedGroup}`);
        } else {
            alert("Please select tournament and group.")
        }
    };

    const goToDailyResult = () => {
        navigate(`daily-results/${selectedTournament}`);
        dispatch(setIsFinalDailyResult(null))
    };

    const gotToLiveScoreDarts = () => {
        if (!selectedGame && selectedTournament) {
            return navigate(`darts/livescore/${selectedTournament}`);
        }
        //const typeName = DartsGameType[game.type].toLowerCase();

        //return navigate(`darts/livescore/${typeName}/${game.id}`);

        //const chosenGame = games.find((game: DartsGame) => game.id === selectedGame)
        // if (chosenGame!.is9shots) {
        //     return alert("This widget for regular games only ")
        // }

        navigate(`darts/livescore/${selectedGame}`);
    };


    return (
        <Fragment>
            {pages['leagueTable'] &&
                <Button id="league_table" color="brown" onClick={goToLeagueList}>League table</Button>
            }
            {pages['dailyResult'] &&
                <Button id="daily_result" color="olive" onClick={() => goToDailyResult()}>Daily results</Button>
            }
            {!!selectedTournament && pages['liveScore'] &&
                <Button id="live_score" color="blue" onClick={gotToLiveScoreDarts}>Live score</Button>
            }
        </Fragment>
    );
};

export default DartsEventManagerInformButtons;
